import { Trans } from "@lingui/react/macro";
import { useFormContext, type FieldValues } from "react-hook-form";
import { FilledButton, OutlinedButton } from "@medoma/components/Button/Button";
import type { IActivityCategory } from "@medoma/models/activities";
import type { IPatientId } from "@medoma/models/patients";
import { ActivityFields } from "./ActivityFields";
import styles from "./RegisterActivityRetroactivelyForm.module.scss";

type NewActivityPanelProps = {
  index: number;
  patientId: IPatientId;
  category: IActivityCategory;
  onSave: () => void;
  onCancel: () => void;
};

export const NewActivityPanel = ({
  index,
  patientId,
  category,
  onSave,
  onCancel,
}: NewActivityPanelProps) => {
  const { trigger } = useFormContext<FieldValues>();

  const handleSave = async () => {
    const isValid = await trigger(`activities.${index}`);
    if (isValid) {
      onSave();
    }
  };

  return (
    <article className={styles.activityPanel}>
      <section className={styles.newActivityPanelContent}>
        <ActivityFields
          patientId={patientId}
          category={category}
          namePrefix={`activities.${index}`}
        />
        <div className={styles.actionButtons}>
          <FilledButton type="button" onClick={handleSave}>
            <Trans>Klar</Trans>
          </FilledButton>
          <OutlinedButton type="button" onClick={onCancel}>
            <Trans>Avbryt</Trans>
          </OutlinedButton>
        </div>
      </section>
    </article>
  );
};
